import { BoxProps, Center, Text } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  placeholder?: string;
}

const ComparisonItemEmpty: React.FC<Props & BoxProps> = ({
  placeholder,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Center
      w="100%"
      color="gray.300"
      borderRadius="lg"
      border="2px"
      borderColor="gray.50"
      borderStyle="dashed"
      p={{ base: '2', laptopL: '4' }}
      {...props}
    >
      <Text textStyle="smallBody" textAlign="center">
        {placeholder || t('Add another offer in order to compare')}
      </Text>
    </Center>
  );
};

export default ComparisonItemEmpty;
